<template>
  <div
    id="createFolderELearningModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ this.$route.meta.breadcrumb }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label class="label-required">ชื่อหมวดหมู่</label>
                      <input
                        type="text"
                        class="form-control"
                        id="cfelFolderName"
                        name="cfelFolderName"
                        v-model="cfelFolderName"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="la la-save"></i> บันทึก
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {
  },
  data: function() {
    var self = this;
    return {
      cfelFolderName : null

      };
  },
  methods: {
    formSubmit: function(e) {
      e.preventDefault();
      let self = this;

      if (
        !$("#createFolderELearningModal form")
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;
      axios({
        method: "post",
        url: "/Api/Folder/AddFolder",
        data: {
          folderName : self.cfelFolderName,
          level : 1
        }
      })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                $("#createFolderELearningModal").modal("hide");
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            error.response.data.message,
            "error"
          ).then(function() {
            $("#createFolderELearningModal").modal("hide");
          });
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    //console.log(this.$route.params.id);
    
    if(router.currentRoute.params.id != undefined){
      //Call api get foldername
    }

    // set validation rules
    $("#createFolderELearningModal form").validate({
      rules: {
        cfelFolderName: "required"
      },
      messages: {
        cfelFolderName: "กรุณาระบุโฟลเดอร์"
      },
    });

    $("#createFolderELearningModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        self.$parent.reloadDataTable(false);
      })
      .modal("show");
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/5S/FolderELearningModal.vue